// User requests
export const USER_CREATE = "USER_CREATE";
export const USER_LIST = "USER_LIST";
export const USER_UPDATE = "USER_DETAIL"
export const USER_FILTER = "USERS_FILTER";

// User success
export const USER_CREATE_SUCCESS = "USER_CREATE_SUCCESS";
export const USER_UPDATE_SUCCESS = "USER_DETAIL_SUCCESS"
export const USER_LIST_SUCCESS = "USER_LIST_SUCCESS";

// User failed
export const USER_REQUEST_FAILED = "USER_REQUEST_FAILED";
